import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const WhatWeDo = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const stats = [
    { value: 50, suffix: "+", label: "Projects Delivered" },
    { value: 20, suffix: "+", label: "Brands Designed" },
    { value: 30, suffix: "+", label: "Websites Designed" },
    { value: 10, suffix: "+", label: "Industries Served" },
    { value: 100, suffix: "%", label: "Client Satisfaction" },
  ];

  return (
    <section
      id="services"
      className="relative bg-[#ffffff]"
      style={{ fontFamily: "'Poppins', sans-serif" }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-16">
        <div
          ref={ref}
          className="grid grid-cols-3 sm:grid-cols-5 gap-4"
        >
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <div
                className="font-bold text-gray-300 leading-none"
                style={{
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontSize: "clamp(2rem, 4vw, 2.8rem)",
                }}
              >
                {inView ? (
                  <CountUp
                    start={0}
                    end={s.value}
                    duration={2.5}
                    suffix={s.suffix}
                  />
                ) : (
                  `0${s.suffix}`
                )}
              </div>

              <div className="text-xs text-gray-400 mt-2">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;